import { Col, Form, Input, Row, Typography } from "antd";
import appLabel from "../../../../../config/appLabel";
import { BOM } from "../../../../../services/definedMethod";
import { labelConfig } from "../../../glAndAccounting.config";
const { Text } = Typography;

const GLOverview = (props) => {
  const { onFinish, form, formData, glDetail, parentData = [] } = props;
  const parentName = parentData.find(
    (p) => p.value === glDetail?.parentId,
  )?.label;
  const displayValue = (value) =>
    value !== undefined && value !== null && value !== "" ? value : "-";
  const displayDate = (value) => {
    if (!value) return "-";
    if (Array.isArray(value)) {
      return BOM.FormatArrayDate(value) || "-";
    }
    return displayValue(value);
  };
  const displayStatus = (disabled) => {
    if (disabled === true) return "Disabled";
    if (disabled === false) return "Active";
    return "-";
  };
  return (
    <Form
      layout="vertical"
      onFinish={onFinish}
      form={form}
      initialValues={formData}
    >
      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>{appLabel.accountType}</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={displayValue(glDetail?.type?.value)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>{appLabel.GLCode}</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={displayValue(glDetail?.glCode)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>{labelConfig.glName}</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={displayValue(glDetail?.name)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>{appLabel.shortName}</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={displayValue(glDetail?.shortName || glDetail?.name)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>{appLabel.accountUsage}</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={displayValue(glDetail?.usage?.value || glDetail?.usage)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>{appLabel.tag}</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={displayValue(glDetail?.tagId?.name || glDetail?.tagId)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>{appLabel.manualEntriesAllowed}</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={
                glDetail?.manualEntriesAllowed === true
                  ? "Yes"
                  : glDetail?.manualEntriesAllowed === false
                    ? "No"
                    : "-"
              }
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>{appLabel.category}</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={displayValue(
                glDetail?.category?.value || glDetail?.category,
              )}
            />
          </Form.Item>
        </Col>
        {/* <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>{labelConfig.accountLevel}</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={displayValue(
                glDetail?.accountLevel?.value || glDetail?.accountLevel,
              )}
            />
          </Form.Item>
        </Col> */}
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>{appLabel.parent}</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={displayValue(parentName || glDetail?.parentId)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>{labelConfig.accountStatus}</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={displayStatus(glDetail?.disabled)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>{labelConfig.naturalBalance}</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={displayValue(
                glDetail?.naturalBalance?.value || glDetail?.naturalBalance,
              )}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text strong>{labelConfig.regulatoryReportingCode}</Text>}
          >
            <Input
              className="of-bold-disable-input"
              disabled
              value={displayValue(glDetail?.reportingCode || glDetail?.glCode)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text strong>{labelConfig.ifrsClassification}</Text>}
          >
            <Input
              className="of-bold-disable-input"
              disabled
              value={displayValue(
                glDetail?.ifrsClassification?.option?.value ||
                  glDetail?.ifrsClassification?.value ||
                  glDetail?.ifrsClassification,
              )}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>{labelConfig.taxCategory}</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={displayValue(
                glDetail?.taxCategory?.value || glDetail?.taxCategory,
              )}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>{labelConfig.openingDate}</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={displayDate(
                glDetail?.openingDate || glDetail?.approvedOnDate,
              )}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text strong>{labelConfig.closingDate}</Text>}>
            <Input
              className="of-bold-disable-input"
              disabled
              value={displayDate(
                glDetail?.closingDate || glDetail?.approvedOnDate,
              )}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default GLOverview;
